<template>
	<div :class="classes">
		<div :class="segmentClasses( segment )"
			v-for="segment in segments"
			:key="segment.id"
			@click="onSegmentClick( segment )"
		>
			<div class="text">{{ segment.label }}</div>
			<div class="divider">&nbsp;</div>
		</div>
	</div>
</template>

<script>

export const makeSegment = ( { id = "", label = "", isActive = false, disabled = false, count, } ) => {
	const tab = {
		id,
		label,
		isActive,
		disabled,
	};

	if ( count !== undefined ) {
		tab.count = count;
	}

	return tab;
};

export default {
	name: "VariableSegmentedButton",
	emits: [ "change", ],
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { id:String, label:String, isActive:Boolean, disabled:Boolean, [count:Number], }, ... ] */
		segments: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		classes() {
			return {
				"variable-segmented-button": true,
			};
		},
	},
	methods: {
		segmentClasses( segment ) {
			return {
				"text-noselect": true,
				segment: true,
				"segment--active": segment.isActive,
				"segment--disabled": !!segment.disabled,
			};
		},
		onSegmentClick( segment ) {
			const { disabled, } = this;
			if ( disabled || !!segment.disabled ) {
				return;
			}
			this.$emit( "change", segment.id );
		},
	},
};
</script>

<style lang="scss" scoped>
$backgroundColor: $color1-050;
$borderColor: $color1-100;
$segmentColor: $color1-500;
$segmentBackgroundColor: $color1-050;
$segmentColor--active: $color2-500;
$segmentBorderColor--active: $color1-200;
$segmentColor--disabled: $color1-200;

.variable-segmented-button {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	background-color: $backgroundColor;
	border: 0.0625rem solid $borderColor;
	border-radius: 0.5rem;
}

.segment {
	flex: 1;

	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;

	padding: 0.625rem 0 0.625rem 0.375rem;

	.text { flex: 1; }
	// divider width + border = left padding width
	.divider { width: 0.3125rem; border-right: 0.0625rem solid $borderColor; font-weight:600; }

	@include font-and-line-for(1);
	font-weight: 600;

	color: $segmentColor;
	background-color: $segmentBackgroundColor;

	border: 0.0625rem solid transparent;
	border-radius: 0.5rem;

	text-align: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;

	cursor: pointer;
}

.segment:last-of-type {
	.divider { border-color: transparent; }
}

.segment--disabled {
	cursor: not-allowed;
	color: $segmentColor--disabled;
}

.segment--active {
	color: $segmentColor--active;
	background-color: $white;

	border: 0.0625rem solid $segmentBorderColor--active;
	box-shadow: 0 0.1875rem 0.375rem 0.0625rem rgba(33, 45, 99, 0.1), 0 1.3125rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2);

	cursor: default;

	.divider { border-color: transparent; }
}
</style>
